import { render, staticRenderFns } from "./PopupAddDateToClinic.vue?vue&type=template&id=f7708352&scoped=true&"
import script from "./PopupAddDateToClinic.vue?vue&type=script&lang=ts&"
export * from "./PopupAddDateToClinic.vue?vue&type=script&lang=ts&"
import style0 from "./PopupAddDateToClinic.vue?vue&type=style&index=0&id=f7708352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7708352",
  null
  
)

export default component.exports